import { useState, React } from 'react';
import { Fade } from 'react-awesome-reveal'
import emailjs from 'emailjs-com';
import swal from 'sweetalert';
import contactLight from '../media/contact-light.svg';
import contactDark from '../media/contact-dark.svg';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/esm/Button'
import Container from 'react-bootstrap/esm/Container'
import Row from 'react-bootstrap/esm/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin, faMedium } from '@fortawesome/free-brands-svg-icons';
import connectLight from '../media/connect-light.webp';
import connectDark from '../media/connect-dark.webp';
const Contact = ({ darkMode }) => {

    const [templateParams, setTemplateParams] = useState({
        from_name: '',
        message: ''
    });

    const onInputChange = e => {
        setTemplateParams({ ...templateParams, [e.target.name]: e.target.value })
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        emailjs.send('service_c4rmgzp', 'template_tky56rv', templateParams, '-l6mih7Ht8Uy33Csx')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
            }, (err) => {
                console.log('FAILED...', err);
            });
        swal({
            title: "Sent Successfully!",
            text: "Glad to hear from you! I will get back to you as soon possible",
            icon: "success",
        });
        setTemplateParams({
            from_name: '',
            message: ''
        })
    }

    return (
        <div data-theme={darkMode ? "dark" : "light"}>
            <br />
            <h2 className="lead text-center" >Contact me!</h2>
            <Fade>
            
                <Container>
                    <Row>
                        <Col lg={4}  >
                            <br />
                            {/* <h2 className="lead">Contact me!</h2> */}
                            <p className="contact-text">Drop a suggestion, feedback, opportunities or we can colaborate on a project. Please mention your contact details if you are expecting a reply.</p>
                            {/* <br /> */}
                            {/* <img src={darkMode ? contactDark : contactLight} alt="contact" className="contact-img img-fluid" height="150px" width="228px" /> */}
                            {/* <Col lg={4} align='center'> */}
                            {/* <Card className="nbcard"> */}
                            {/* <Card.Body  className="pl-0" > */}
                            <Card.Body style={{textAlign:'center'}} >
                                <Card.Title><p className="lead" style={{display:'inline-block',marginBottom:'0px',margin:"auto"}} >Let's Connect!</p></Card.Title>
                                {/* <br /> */}
                                <p   >aniketpilankar1998@gmail.com</p>
                                <a href="https://www.linkedin.com/in/aniket-pilankar-534202213/" target="_blank" rel="noreferrer noopener">
                                    <Button variant={darkMode ? "outline-light" : "outline-dark"} className='a'>
                                        <FontAwesomeIcon className="dark" size="lg" icon={faLinkedin} /> Aniket Pilankar
                                    </Button>
                                </a>
                                <a href="https://github.com/Aniket-Pilankar" target="_blank" rel="noreferrer noopener">
                                    <Button variant={darkMode ? "outline-light" : "outline-dark"}>
                                        <FontAwesomeIcon className="dark" size="lg" icon={faGithub} /> Aniket Pilankar
                                    </Button>
                                </a>
                                <a href="https://medium.com/@aniketpilankar1998" target="_blank" rel="noreferrer noopener">
                                    <Button variant={darkMode ? "outline-light" : "outline-dark"}>
                                        <FontAwesomeIcon className="dark" size="lg" icon={faMedium} /> Aniket Pilankar
                                    </Button>
                                </a>
                                {/* <img src={darkMode ? connectDark : connectLight} alt="connect" className="connect-img img-fluid animated" height="187px" width="290px" /> */}
                            </Card.Body>
                            {/* </Card> */}
                            {/* </Col> */}
                            <br />
                        </Col>
                        <Col lg={8}>
                            <br />
                            <Form onSubmit={e => onSubmit(e)}>
                                <Form.Group>
                                    <Form.Control onChange={e => onInputChange(e)} value={templateParams.from_name} name="from_name" className="ph name" type="name" placeholder="Enter your name" required />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Control onChange={e => onInputChange(e)} value={templateParams.message} name="message" as="textarea" rows={8} className="ph msg" placeholder="Enter your message" required />
                                </Form.Group>
                                <Button variant={darkMode ? "outline-light" : "outline-dark"} type="submit">
                                    Submit
                                </Button>
                            </Form>
                        </Col>
                        <br />
                    </Row>
                </Container>
            </Fade>
        </div>
    )
}

export default Contact
